import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { Asset, Attachment } from '../../../core/store/models';
import { SortObject, TableTypes } from '../../../core/store/types';
import { AttachmentUploadModalComponent } from '../attachment-upload-modal/attachment-upload-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

@Component({
    selector: 'ah-attachments',
    templateUrl: './attachments.component.html',
    styleUrls: ['./attachments.component.scss'],
    standalone: false
})
export class AttachmentsComponent implements OnChanges {
    @Input() attachments: Attachment[] = [];
    @Input() confirmDeleteMessage = 'Are you sure you want to delete this attachment?';
    @Input() deleteEnabled = true;
    @Input() ownerEntity: Asset;
    @Input() uploadMultiple = false;
    @Input() uploadUrl: string;
    @Input() tableType: TableTypes;
    @Input() showAttachmenttype?: boolean = false;

    @Output() add: EventEmitter<{ id: number; attachment: Attachment | Attachment[] }> = new EventEmitter();
    @Output() delete: EventEmitter<Attachment> = new EventEmitter();
    @Output() sort: EventEmitter<SortObject> = new EventEmitter();

    currentSort: SortObject = { field: 'id', order: 1, args: [] };
    rowsPerPage = 50;

    constructor(public dialog: MatDialog) { }

    ngOnChanges(changes) {
        if (changes.attachments && changes.attachments.currentValue) {
            this.attachments = changes.attachments.currentValue.slice();
        }
    }

    sortAttachments(sortObject: SortObject) {
        if (!this.currentSort || this.currentSort.field !== sortObject.field || this.currentSort.order !== sortObject.order) {
            this.sort.emit(sortObject);
            this.currentSort = sortObject;
        }
    }

    addAttachment() {
        const dialogRef = this.dialog.open(AttachmentUploadModalComponent, {
            data: { owner: this.ownerEntity, uploadUrl: this.uploadUrl, uploadMultiple: this.uploadMultiple }
        });
        dialogRef.afterClosed().pipe(take(1)).subscribe(attachment => {
            if (attachment) {
                if (this.tableType === TableTypes.FranchiseGroupTable || this.tableType === TableTypes.DivisionGroupTable || this.tableType === TableTypes.StudioGroupTable || this.tableType === TableTypes.StudioSubGroupTable || this.tableType === TableTypes.DivisionSubGroupTable || this.tableType === TableTypes.FranchiseSubGroupTable) {
                    this.add.emit({ id: this.ownerEntity.id, attachment });
                } else {
                    attachment.map(attachment => this.add.emit({ id: this.ownerEntity.id, attachment }));
                };
            }
        });
    }

    deleteAttachment(attachment) {
        this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Confirm Delete',
                message: this.confirmDeleteMessage,
                confirmButton: 'Delete',
                confirmColor: 'warn'
            }
        }).afterClosed().pipe(take(1)).subscribe(del => {
            if (del) {
                this.delete.emit(attachment);
            }
        });
    }

    showPaginator(attachments) {
        return attachments && attachments.length && attachments.length > this.rowsPerPage;
    }
}
